import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetDept/Main";
import Form from "./TbSetDept/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDatatype } from "../../../model/InitialData/InitialDataCreditor";

const TbSetDept = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  //   const [dataAPtype, setDataAPtype] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDatatype());
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_AP ทั้งหมด
      const masterList = await getData("Tb_Set_Dept", "1=1");
      //   const dataAPtype = await getData("Tb_Set_APType", "1=1");
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      //   if (dataAPtype && dataAPtype.length > 0) {
      //     setDataAPtype(dataAPtype);
      //   }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");

    setFormData({
      Dept_Id: 0,
      Dept_Name: "",
      Dept_Status: "Y",
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#EF6C00",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div
          className={`main-panel ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลแผนก"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลแผนก"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  //   dataAPtype={dataAPtype}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetDept;
